var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KSelect',{attrs:{"label":"Select options","options":_vm.longOptions,"multiple":true,"value":[_vm.longOptions[0], _vm.longOptions[1]],"clearable":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }